
import { func } from '../../main';
import axios from '../../api'
import router from '../../router';

const state = {
    TaskWorkList: [],
    TaskWorkNo: "",
    Loading:false
  
};


const getters = {
    GetTaskWorkList(state:any) {
        return state.TaskWorkList;
    },
    GetTaskWorkNo(state:any) {
        return state.TaskWorkNo;
    },
   
};

const mutations = {
  
    SetTaskWorkList(state:any, list:any) {
        state.TaskWorkList = list;
    },
    AddTaskWorkList(state:any, list:any) {
        state.TaskWorkList.push.apply(state.TaskWorList, list)
    },
    SetTaskWorkNo(state:any, no:any) {
        state.TaskWorkNo = no;
    },
   
   
};

const actions = {
    GetTaskWorkListFromServer(context:any, Filter:any) {
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("TaskWork/GetTaskWorkListForShow", {
            params: {
                taskFolderId: Filter.taskFolderId
            }
        })
           .then(data => {
                context.commit("SetLoading", false);
                context.commit("SetTaskWorkList", data.data);
            });
    },
    ClearTaskWorkList(context:any) {
        context.commit("SetTaskWorkList", []);
    },
    CreateTaskWork(context:any, item:any) {
        context.commit("SetLoading", true);

        axios.post('TaskWork/CreateTaskWork', item).then((response:any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a:any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                router.push('/TaskList');
            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    EditTaskWork(context:any, item:any) {
        context.commit("SetLoading", true);

        axios.post('TaskWork/EditTaskWork', item).then((response:any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a:any) => a.errorMessage);
                alert(res.join('\n'));
            }
            else {
                router.push('/TaskList');
            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
   
};

export default {
    state,
    getters,
    mutations,
    actions
};
